import apiUrl from '../../api-url';
import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";

// URLS
const ROLES_URL = apiUrl('/iam/roles');

// Actions
const RECEIVE_ROLES = 'Roles/RECEIVE_ROLES';

const duck = buildFetchDuck('roles');

// Action creators
export function fetchRoles() {
  const url = `${ROLES_URL}`;
  return dispatch => dispatch(duck.fetch(url));
}

const initialState = {
    data: []
};

function RolesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_ROLES:  
      return {
          ...state,
          data: action.payload
      };  
    default:
      return state
  }
}

export default RolesReducer;




// WEBPACK FOOTER //
// ./src/modules/roles/RolesState.js